<template>
  <header class="mobile-header">
    <header-logo @click="onClickHeaderLogo"/>
  </header>
</template>

<script>
import HeaderLogo from 'assets/svg/header-logo.vue'

export default {
  name: 'MobileHeader',
  components: {HeaderLogo},
  methods: {
    onClickHeaderLogo() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-header {
  display: flex;
  z-index: 100;
}
</style>
